export enum LocationTypeId {
  General = 1,
  Care = 3,
  Dropbox = 2,
  Self_Pick_Up_Station = 4,
}
